import { forwardRef, type SVGProps } from 'react';

export type BrainIconProps = Omit<SVGProps<SVGSVGElement>, 'css'>;

export const BrainIcon = forwardRef<SVGSVGElement, BrainIconProps>((props, ref) => (
  <svg ref={ref} {...props} aria-hidden="true" fill="none" viewBox="0 0 16 16">
    <g clip-path="url(#a)">
      <path
        d="M9.496.8a2.583 2.583 0 0 1 3.063 2.19 3.25 3.25 0 0 1 2.022 3.141 3.3 3.3 0 0 1-.2.992 3.25 3.25 0 0 1-.403 4.789q-.03.023-.063.046a3.25 3.25 0 0 1-1.767 2.932A3.25 3.25 0 0 1 8 13.854a3.25 3.25 0 0 1-1.571 1.203 3.25 3.25 0 0 1-4.345-3.1l-.063-.045a3.25 3.25 0 0 1-.403-4.789 3.25 3.25 0 0 1 .942-3.6 3.3 3.3 0 0 1 .88-.533 2.58 2.58 0 0 1 .857-1.6A2.583 2.583 0 0 1 8 1.699 2.6 2.6 0 0 1 9.496.8m-3.22 1.144a1.417 1.417 0 0 0-1.503 2.098.584.584 0 0 1-1.01.583 2.6 2.6 0 0 1-.188-.4 2.08 2.08 0 0 0-.945 2.217.583.583 0 0 1 .328 1.087A2.085 2.085 0 0 0 4 11.417a.584.584 0 0 1 0 1.166q-.349 0-.686-.074.008.033.017.064A2.084 2.084 0 0 0 7.416 12V8.545a3.4 3.4 0 0 1-1.253.682.584.584 0 0 1-.327-1.12A2.2 2.2 0 0 0 7.416 6V3.333a1.416 1.416 0 0 0-1.14-1.39M8.583 6l.008.177a2.2 2.2 0 0 0 1.572 1.93.584.584 0 0 1-.327 1.12 3.4 3.4 0 0 1-1.253-.682v3.454l.003.107a2.083 2.083 0 0 0 4.083.467l.016-.064a3.3 3.3 0 0 1-.685.074.583.583 0 1 1 0-1.166 2.083 2.083 0 0 0 1.041-3.888.583.583 0 0 1 .328-1.087 2.08 2.08 0 0 0-.945-2.217q-.075.207-.187.4a.584.584 0 0 1-1.01-.583 1.416 1.416 0 1 0-2.641-.79l-.003.081z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path d="M0 0h16v16H0z" fill="currentColor" />
      </clipPath>
    </defs>
  </svg>
));

BrainIcon.displayName = 'BrainIcon';
